<template>
    <Title_Base :icon="icon" :title="text">
    </Title_Base>
</template>


<script>
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";
import EmailTemplates from "@/helpers/Constants/EmailTemplates.js";

export default {
    name: 'Title_EmailTemplate',
    props: {},
    components: {
        Title_Base,
    },

    data() {
        return {};
    },

    methods: {},

    computed: {
        templateKey() {
            return this.$route?.params?.emailTemplate || '';
        },

        templateMeta() {
            return EmailTemplates[this.templateKey] || null;
        },

        icon() {
            return this.$route?.meta?.icon || 'mdi-email-newsletter';
        },

        text() {
            return this.templateMeta?.title || this.templateKey || 'Email template';
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>
